module.exports = __webpack_public_path__ + "static/img/14000283.8d7367fe.png";